function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M119.5 87.698v6.266h2.11c4.25 0 7.695 3.478 7.695 7.767v12.821h6.195V100.52c0-7.082-5.683-12.821-12.692-12.821H119.5zM8.5 104.5h102v10H8.5zM5 .5A4.5 4.5 0 00.5 5v95a4.5 4.5 0 004.5 4.5h110a4.5 4.5 0 004.5-4.5V5A4.5 4.5 0 00115 .5H5z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M8 73.5h20m-20 5h20m-20-25h20m-20 5h20m-20 25h20m-20 5h20m-20-25h20m-20 5h20m-20 25h20m-20 5h20m8-20h20m-20 5h20m-20 5h20m-20 5h20m-20 5h20m8-20h20m-20 5h20m-20 5h20m-20 5h20m-20 5h20m8-25h20m-20 5h20m-20-25h20m-20 5h20m-20 25h20m-20 5h20m-20-25h20m-20 5h20m-20 25h20m-20 5h20M8 28.5h20M8 23.5h20M8 48.5h20M8 43.5h20M8 18.5h20M8 13.5h20M8 38.5h20M8 33.5h20M8 8.5h20M36 28.5h20M36 23.5h20M36 18.5h20M36 13.5h20M36 8.5h20M64 28.5h20M64 23.5h20M64 18.5h20M64 13.5h20M64 8.5h20M92 28.5h20M92 23.5h20M92 48.5h20M92 43.5h20M92 18.5h20M92 13.5h20M92 38.5h20M92 33.5h20M92 8.5h20M45.952 42l8.334 8.333m0-8.333l-8.334 8.333M65 42l8.333 8.333m0-8.333L65 50.333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.286 66.405c-5.33-.797-12.941-1.951-19.36-1.951-7.246 0-14.126.953-19.926 1.95"
}));

function SvgEmergencyHvacLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 116,
    viewBox: "0 0 136 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyHvacLarge);
export default __webpack_public_path__ + "static/media/EmergencyHvacLarge.2699a9a1.svg";
export { ForwardRef as ReactComponent };